export const CDP_SCREEN_NAME_FOR_ROUTE = {
  'signup.please-wait': 'eligibility_check',
  'signup.confirm-identity.index': 'confirm_id',
  'signup.confirm-business.index': 'confirm_biz',
  'signup.enter-identity-info.index': 'confirm_id',
  'signup.enter-business-info.index': 'confirm_biz',
  'signup.agreement': 'agreement',
  'signup.business-type': 'biz_type',
  'signup.two-factor.enroll': '2FA_enroll',
  'signup.two-factor.sms': '2FA_sms',
  'signup.two-factor.google-authenticator': '2FA_google_authenticator',
  'signup.account-open': 'account_open',
};
